import { render, staticRenderFns } from "./SystemCMS.vue?vue&type=template&id=ab46f2da&scoped=true&"
import script from "./SystemCMS.vue?vue&type=script&lang=js&"
export * from "./SystemCMS.vue?vue&type=script&lang=js&"
import style0 from "./SystemCMS.vue?vue&type=style&index=0&id=ab46f2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab46f2da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VLayout,VRow,VSpacer,VTextField})
